import useSWR from "swr";
import { api } from "../services";

const BASE_URL = "/system-admin/preemploymentrequirements";

export const usePreEmploymentRequirements = (query = {}) => {
  const qs = new URLSearchParams(query).toString();
  const key = qs ? `${BASE_URL}?${qs}` : BASE_URL;
  const { data, isLoading, mutate } = useSWR(key, api.get);

  return {
    isLoading,
    data,
    count: data?.length,
    mutate,
  };
};
